import { render, staticRenderFns } from "./CreateCustomerModal.vue?vue&type=template&id=317facbe&scoped=true"
import script from "./CreateCustomerModal.vue?vue&type=script&lang=js"
export * from "./CreateCustomerModal.vue?vue&type=script&lang=js"
import style0 from "./CreateCustomerModal.vue?vue&type=style&index=0&id=317facbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317facbe",
  null
  
)

export default component.exports